import {
  SAVING_FRESHSALES_REQUEST, SAVING_FRESHSALES_SUCCEDDED, SAVING_FRESHSALES_FAILED,
  FETCHING_FRESHSALES_INTEGRATION_REQUEST, FETCHING_FRESHSALES_INTEGRATION_SUCCEDDED, FETCHING_FRESHSALES_INTEGRATION_FAILED
} from '../../actions/actionTypes.jsx';

import { combineReducers } from 'redux';

const initialState = {
  changes: {
    saving: false,
    error: null
  }
};

function freshsalesReducer(state = initialState, action) {
  switch (action.type) {
    case SAVING_FRESHSALES_REQUEST:
      return Object.assign({}, state, {
        ...state,
        changes: {
          ...state.changes,
          saving: true,
          error: null
        }
      })
    case SAVING_FRESHSALES_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          ...state.changes,
          saving: false,
          error: null
        }
      })
    case SAVING_FRESHSALES_FAILED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          ...state.changes,
          saving: false,
          error: action.payload
        }
      })  
    case FETCHING_FRESHSALES_INTEGRATION_REQUEST:
      return Object.assign({}, state, {
        ...state,
        changes: {
          ...state.changes,
          loading: true
        }
      }) 
    case FETCHING_FRESHSALES_INTEGRATION_SUCCEDDED: 
      return Object.assign({}, state, {
        ...state,
        changes: {
          ...state.changes,
          loading: false
        }
      }) 
    case FETCHING_FRESHSALES_INTEGRATION_FAILED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          ...state.changes,
          loading: false
        }
      }) 

    default:
      return state
  }
}

export { freshsalesReducer };